import React from 'react';

import isClientSide from '~/auth/isClientSide';

export const useClientSide = () => {
  const [isOnClientSide, setIsOnClientSide] = React.useState(false);
  React.useEffect(() => {
    if (isClientSide()) {
      setIsOnClientSide(true);
    }
  }, []);
  return isOnClientSide;
};
